<template>
  <div
    ref="containerRef"
    class="col-span-1 relative flex flex-col md:flex-row justify-center items-center"
  >
    <div class="relative text-center md:text-start text-white">
      <div class="md:absolute mb-4 md:mb-0 md:-left-8 md:-top-6">
        <FontAwesomeIcon
          v-if="statisticIcon"
          :icon="statisticIcon"
          class="text-5xl md:text-6xl lg:text-7xl text-[#06395E]"
        />

        <img
          v-else
          :src="statisticImg"
          alt=""
          class="block mx-auto w-fit max-h-20 lg:max-h-25"
        >
      </div>

      <p class="relative text-xl xs:text-2xl lg:text-3xl 2xl:text-4xl font-bold mb-0">
        {{ dynamicNumber.toLocaleString() }}{{ showPlus ? '+' : '' }}
      </p>
      <p class="relative text-md text-wrap break-words md:max-w-40 mb-0">
        {{ statistic }}
      </p>
    </div>
  </div>
</template>

<script setup>

import { ref, onMounted } from 'vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

const props = defineProps({
  statistic: String,
  statisticNumber: String,
  showPlus: Boolean,
  statisticIcon: Object,
  statisticImg: String,
});

const containerRef = ref(null);
const dynamicNumber = ref(0);

onMounted(() => {
  const endNumber = parseInt(props.statisticNumber.replace(/,/g, ''), 10);
  const observer = new IntersectionObserver((entries, observer) => {
    if (entries[0].isIntersecting) {
      animateNumber(endNumber - (endNumber * 0.05 > 20 ? endNumber * 0.05 : 20), endNumber, 1000);
      observer.disconnect(); // Disconnect observer once animation starts
    }
  });

  if (containerRef.value) {
    observer.observe(containerRef.value);
  }
});

function animateNumber(start, end, duration) {
  let startTime = null;

  function step(timestamp) {
    if (!startTime) startTime = timestamp;
    const progress = timestamp - startTime;
    const current = Math.min(start + (end - start) * (progress / duration), end);

    dynamicNumber.value = Math.floor(current);

    if (progress < duration) {
      requestAnimationFrame(step);
    }
  }

  requestAnimationFrame(step);
}
</script>
